import { IconProps } from "./interfaces/IconProps.interface"
import alertCircle from "./alertCircle"
import bankNote from "./bankNote"
import clockRefresh from "./clockRefresh"
import logout from "./logout"
import menu from "./menu"
import check from "./check"
import close from "./Close"
import lock04 from "./lock04"
import lockUnLocked04 from "./lockUnlocked04"
import habitacion from "./habitaciones"
import reservas from "./reservas"
import personal from "./persona"
import money from "./money"
import inventario from "./inventarion"
import checkFilled from "./CheckFilled"
import CheckBoxMultipleFill from "./CheckBoxMultipleFill"
import timer from "./Timer"
import userCheckFilled from "./UserCheckFilled"
import userParent from "./UserParent"
import walking from "./Walking"
import car from "./Car"
import broom from "./Broom"
import userFilled from "./UserFilled"
import userStarFill from "./UserStarFill"
import timeout from "./Timeout"
import userTimer from "./UserTimer"
import pointer from "./Pointer"
import roomServiceCommand from "./RoomServiceCommand"
import trash from "./IconTrash"
import trashFilled from "./TrashFilled"
import tools from "./Tools"
import minusFilled from "./MinusFilled"
import communication from "./Communication"
import calendar from "./Calendar"
import calendarChecked from "./CalendarChecked"
import calendarCross from "./CalendarCross"
import user01 from "./user01"
import userGroupFill from "./UserGroupFill"
import calendar01 from "./calendar01"
import xclose from "./xclose"
import plus from "./plus"
import minus from "./minus"
import chevronUp from "./ChevronUp"
import chevronRight from "./ChevronRight"
import dot from "./Dot"
import creditCard from "./CreditCard"
import mail01 from "./Mail01"
import phone from "./Phone"
import bookMark from "./BookMark"
import building from "./Building"
import calendarClean from "./CalendarClean"
import users from "./Users"
import chevronleft from "./chevron-left"
import searchsm from "./search-sm"
import dotsGrid from "./dots-grid"
import rows01 from "./rows-01"
import coins02 from "./coins02"
import coin10 from "./coin10"
import hash01 from "./hash-01"
import columns from "./Columns"
import optionsGroup from "./OptionsGroup"
import searchLg from "./SearchLg"
import biling from "./Biling"
import messageCircle from "./MessageCircle"
import fileX from "./FileX"
import cubeCash from "./cubeCash"
import checkSquareBroken from "./check-square-broken"
import IconArrowDateLefth from "./arrowLeft"
import BedFilled from "./BedFilled"
import UserParentFill from "./UserParentFill"
import Clock from "./Clock"
import Cutlery from "./Cutlery"
import Ring from "./Ring"
import LockUnlockFill from "./LockUnlockFill"
import LockFill from "./LockFill"
import pencil from "./Pencil"
import bookClosed from "./bookClosed"
import icoInfo from "./iconInfo"
import bookRemix from "./bookRemix"
import restaurantFill from "./restaurantFill"
import accountBoxFill from "./accountBoxFill"
import building4Fill from "./building4Fill"
import arrowSelectRoom from "./arrowSelectRoom"
import currencySymbol from "./CurrencySymbol"
import fileEdit from "./FileEdit"
import changeDollar from "./ChangeDollar"
import coinsFill from "./CoinsFill"
import plusCircle from "./plusCircle"
import camara01 from "./camera01"
import edith02 from "./edit02"
import runner from "./Runner"
import userAdd from "./UserAdd"
import openDoor from "./OpenDoor"
import calendarFill from "./CalendarFill"
import dollarCircle from "./DollarCircle"
import currencyRefundFill from "./CurrencyRefundFill"
import currencyFill from "./CurrencyFill"
import arrow04 from "./Arrow4"
import calendarPlus02 from "./calendarPlus02"
import calendarSquare from "./calendarSquare"
import arrowLeft from "./arrowLeft"
import arrowRigth from "./arrowRigth"
import coinMoney from "./coin-money"
import iconHash from "./iconHash"
import book2Fill from "./book2Fill"
import amex from "./Amex"
import mastercard from "./Mastercard"
import visa from "./Visa"
import ArrowLeftFull from "./ArrowLeftFull"
import dashboardFill from "./dashboardFill"
import Warning from "./Warning"
import lock from "./Lock"
import mailFill from "./MailFill"
import eye from "./Eye"
import eyeOff from "./EyeOff"
import userParentSingle from "./UserParentSingle"
import mailOpenFill from "./MailOpenFill"
import spamFill from "./spamFill"
import timerFill from "./timerFill"
import emotionHappy from "./EmotionHappyFill"
import emotionNormal from "./EmotionNormalFill"
import emotionUnhappy from "./EmotionUnhappyFill"
import Search from "./Search"
import Gear from "./gear"
import info from "./info"
import editFill from "./editFill"
import docDraft from "./docDraft"
import billFill from "./billFill"
import clipboard from "./clipboard"
import emptyState from "./emptyState"
import openMailFill from "./OpenMailFill"
import star from "./Star"
import alertFill from "./AlertFill"
import location from "./Location"
import docFill from "./DocFill"
import chat from "./Chat"
import chatFill from "./ChatFill"
import store3Fill from "./store3Fill"
import Dollar from "./Dollar"
import menuDots from "./MenuDots"
import Stopwatch from "./Stopwatch"
import moneyDollarCircleLine from "./moneyDollarCircleLine"
import calendarEvent from "./calendarEvent"
import printer from "./Printer"
import Exchange from "./Exchange"
import BookOpen from "./BookOpen"
import DocumentExcelFilled from "./DocumentExcelFilled"
import save3Fill from "./save3Fill"
import BusinessGlobalFill from "./BusinessGlobalFill"
import list from "./list"
import sort from "./sort"
import MoonFill from "./MoonFill"
import UserThinFilled from "./UserThinFilled"
import Radio from "./Radio"
import coffee from "./Coffee"
import ExclamationFilled from "./ExclamationFilled"
import businessStar from "./BusinessStar"
import HotelFilled from "./HotelFilled"
import cake2fill from "./cake-2-fill"
import phonealertfill from "./phone-alert-fill"
import CoinsFill from "./CoinsFill"
import home3fill from "./home3fill"
import CalendarPlusFilled from "./CalendarPlusFilled"
import draft from "./Draft"
import shopCart from "./ShopCart"
import chatLeft from "./ChatLeft"
import HotelHome from "./HotelHome"
import giftFill from "./GiftFill"
import heart from "./Heart"
import cupFill from "./CupFill"
import UserPlus from "./UserPlus"
import UserContactsFill from "./UserContactsFill"
import SuitcaseFill from "./SuitcaseFill"
import DollarSquare from "./DollarSquare"
import DragDropFill from "./DragDropFill"
import smallDollarSquare from "./smallDollarSquare"
import infoToolTip from "./infoToolTip"
import docs from "./docs"
import BankCard from "./BankCard"
import ExtraTimeIcon from "./ExtraTime"
import SearchWatch from "./SearchWatch"
import Download from "./Download"
import buildingFill from "./BuildingFill"
import buildingTwo from "./BuildingTwo"
import lockOpen from "./LockOpen"
import lockCheck from "./LockCheck"
import googleIcon from "./googleIcon"
import country from "./country"
import mailVerify from "./mailVerify"
import packageFill from "./package"
import HousekeepingCleaning from "./HousekeepingCleaning"
import FoodAndDrink from "./FoodAndDrink"
import FolderOpenFilled from "./FolderOpenFilled"
import HandCoinFilled from "./HandCoinFilled"
import Percent from "./Percent"
import Inbox from "./Inbox"
import priceTag from "./priceTag"
import swapBox from "./swapBox"
import handCoin from "./handCoin"
import bottleMilk from "./BottleMilk"
import OutInbox from "./OutInbox"
import transferFile from "./transferFile"
import surveyFill from "./SurveyFill"
import IconPendingPayment from "./IconPendingPayment"
import Palette from "./Palette"
import MosaicFilled from "./MosaicFilled"
import ZoomIn from "./ZoomIn"
import ZoomOut from "./ZoomOut"
import personalMap from "./personal"
import filterFill from "./FilterFill"
import Origin from "./origin"
import HashWhite from "./hashWhite"
import UserUnfollow from "./UserUnfollow"
import easyRoom from "./easyRoom"
import forbidden from "./forbidden"
import FolderFill from "./folderFill"
import Document from "./document"
import Warehouses from "./Warehouses"
import TypesArticles from "./TypesArticles"
import AdminArticle from "./AdminArticle"
import Processes from "./Processes"
import ControlInputs from "./ControlInputs"
import Recipe from "./Recipe"
import rulerFilled from "./RulerFilled"
import priceTagFilled from "./PriceTagFilled"
import RecipeHistory from "./recipeHistory"
import arrows from "./arrows"
import LeafFill from "./LeafFill"
import Scales2Fill from "./Scales2Fill"
import circleEqual from "./CircleEqual"
import circleMinus from "./CircleMinus"
import circleMore from "./CircleMore"
import IconHelp from "./InconHelp"
import transfer from "./transfer"
import CloseCircle from "./CloseCircle"
import AddCircle from "./addCircle"
import BellRecipes from "./bellRecipes"
import Drink from "./drink"
import Order from "./Order"
import ArrowLongRight from "./ArrowLongRight"
import ExternalLinkFill from "./ExternalLinkFill"
import IconPendingPaymentFill from "./IconPendingPaymentFill"
import image from "./Image"
import computerFill from "./ComputerFill"
import processShape from "./ProcessShape"
import documentBillFill from "./DocumentBillFill"
import WaiterKitchenFilled from "./WaiterKitchenFilled"
import MoreFill from "./MoreFill"
import Insumo from "./Insumo"
import FingerPrint from "./FingerPrint"
import shieldCheck from "./shieldCheck"
import Bell from "./Bell"
import ArrowRightFull from "./ArrowRightFull"
import Table from "./Table"
import PendingPayment from "./PendingPayment"
import DropFill from "./DropFill"
import BlazeFill from "./BlazeFill"
import LightBulb from "./LightBulb"
import ChevronFill from "./ChevronFill"
import PieChartFilled from "./PieChartFilled"
import IconRoomServicePendingPayment from "./IconRoomServicePendingPayment"
import TurnoFill from "./TurnoFill"
import waterFlashFill from "./waterFlashFill"
import Exclamation from "./Exclamation"
import FolderChart from "./FolderChart"
import FilterLines from "./FilterLines"
import Config from "./Config"
import Keynote from "./Keynote"
import MoneyDollarBox from "./MoneyDollarBox"
import ArticleFill from "./ArticleFill"
import Toothbrush from "./Toothbrush"
import CameraPlus from "./CameraPlus"
import FileListFill from "./FileListFill"
import AlarmFill from "./AlarmFill"
import UserSearchFill from "./UserSearchFill"
import ShieldUserFill from "./ShieldUserFill"
import Gender from "./Gender"
import ContactsBook from "./ContactsBook"
import Calendar2Fill from "./Calendar2Fill"
import Earth from "./Earth"
import MapPinFill from "./MapPinFill"
import DoorOpenNew from "./DoorOpenNew"

export const COLLECTION = {
    alertCircle,
    bankNote,
    clockRefresh,
    user01,
    logout,
    menu,
    check,
    close,
    habitacion,
    reservas,
    personal,
    money,
    inventario,
    lock04,
    lockUnLocked04,
    checkFilled,
    CheckBoxMultipleFill,
    timer,
    userCheckFilled,
    userParent,
    walking,
    car,
    broom,
    userFilled,
    userStarFill,
    timeout,
    userTimer,
    pointer,
    roomServiceCommand,
    trash,
    trashFilled,
    tools,
    minusFilled,
    communication,
    calendar,
    calendarChecked,
    calendarCross,
    userGroupFill,
    calendar01,
    xclose,
    plus,
    minus,
    chevronUp,
    chevronRight,
    dot,
    creditCard,
    phone,
    mail01,
    bookMark,
    building,
    calendarClean,
    users,
    chevronleft,
    searchsm,
    dotsGrid,
    rows01,
    coins02,
    coin10,
    hash01,
    columns,
    optionsGroup,
    searchLg,
    biling,
    messageCircle,
    fileX,
    cubeCash,
    checkSquareBroken,
    IconArrowDateLefth,
    BedFilled,
    UserParentFill,
    Clock,
    Cutlery,
    Ring,
    LockUnlockFill,
    LockFill,
    pencil,
    bookClosed,
    icoInfo,
    currencySymbol,
    bookRemix,
    restaurantFill,
    accountBoxFill,
    building4Fill,
    arrowSelectRoom,
    fileEdit,
    changeDollar,
    coinsFill,
    plusCircle,
    camara01,
    edith02,
    runner,
    userAdd,
    openDoor,
    calendarFill,
    dollarCircle,
    currencyRefundFill,
    currencyFill,
    arrow04,
    calendarPlus02,
    calendarSquare,
    arrowLeft,
    arrowRigth,
    coinMoney,
    iconHash,
    book2Fill,
    amex,
    mastercard,
    visa,
    ArrowLeftFull,
    Warning,
    dashboardFill,
    lock,
    mailFill,
    eye,
    eyeOff,
    userParentSingle,
    mailOpenFill,
    spamFill,
    timerFill,
    emotionHappy,
    emotionNormal,
    emotionUnhappy,
    Search,
    Gear,
    info,
    editFill,
    docDraft,
    billFill,
    clipboard,
    emptyState,
    openMailFill,
    star,
    alertFill,
    location,
    docFill,
    chat,
    chatFill,
    store3Fill,
    Dollar,
    menuDots,
    Stopwatch,
    moneyDollarCircleLine,
    calendarEvent,
    printer,
    Exchange,
    BookOpen,
    DocumentExcelFilled,
    MoonFill,
    UserThinFilled,
    Radio,
    save3Fill,
    BusinessGlobalFill,
    ExclamationFilled,
    list,
    sort,
    coffee,
    businessStar,
    HotelFilled,
    cake2fill,
    phonealertfill,
    CoinsFill,
    home3fill,
    CalendarPlusFilled,
    draft,
    shopCart,
    chatLeft,
    HotelHome,
    heart,
    giftFill,
    cupFill,
    UserPlus,
    UserContactsFill,
    SuitcaseFill,
    DollarSquare,
    DragDropFill,
    smallDollarSquare,
    infoToolTip,
    docs,
    BankCard,
    ExtraTimeIcon,
    SearchWatch,
    Download,
    buildingFill,
    buildingTwo,
    googleIcon,
    country,
    mailVerify,
    lockOpen,
    lockCheck,
    packageFill,
    HousekeepingCleaning,
    FoodAndDrink,
    FolderOpenFilled,
    HandCoinFilled,
    Percent,
    Inbox,
    priceTag,
    swapBox,
    handCoin,
    bottleMilk,
    OutInbox,
    transferFile,
    surveyFill,
    IconPendingPayment,
    Palette,
    MosaicFilled,
    ZoomIn,
    ZoomOut,
    personalMap,
    filterFill,
    Origin,
    HashWhite,
    UserUnfollow,
    easyRoom,
    forbidden,
    FolderFill,
    Document,
    Warehouses,
    TypesArticles,
    AdminArticle,
    Recipe,
    Processes,
    ControlInputs,
    rulerFilled,
    priceTagFilled,
    RecipeHistory,
    arrows,
    LeafFill,
    Scales2Fill,
    IconHelp,
    CloseCircle,
    circleEqual,
    circleMinus,
    circleMore,
    transfer,
    BellRecipes,
    Drink,
    Order,
    ArrowLongRight,
    ExternalLinkFill,
    IconPendingPaymentFill,
    image,
    AddCircle,
    computerFill,
    processShape,
    documentBillFill,
    WaiterKitchenFilled,
    MoreFill,
    Insumo,
    FingerPrint,
    shieldCheck,
    Bell,
    ArrowRightFull,
    Table,
    PendingPayment,
    DropFill,
    BlazeFill,
    LightBulb,
    ChevronFill,
    PieChartFilled,
    IconRoomServicePendingPayment,
    TurnoFill,
    waterFlashFill,
    Exclamation,
    FolderChart,
    FilterLines,
    Config,
    Keynote,
    ArticleFill,
    MoneyDollarBox,
    Toothbrush,
    CameraPlus,
    FileListFill,
    AlarmFill,
    UserSearchFill,
    ShieldUserFill,
    Gender,
    ContactsBook,
    Calendar2Fill,
    Earth,
    MapPinFill,
    DoorOpenNew
}
export interface IconNamesProps extends IconProps {
    name: keyof typeof COLLECTION | (string & {})
}

function Icon({ name = "", ...rest }: IconNamesProps): JSX.Element {
    const IconComponent =
        name && COLLECTION[name]
            ? COLLECTION[name]
            : () => <div style={{ height: "1rem", width: "1rem", backgroundColor: "transparent", gap: "10px" }} />

    return <IconComponent {...rest} />
}

export default Icon
